import { ThemeProvider } from "@mui/material";
import { PropsWithChildren, useMemo } from "react";

import { createEncampTheme } from "../theme";
import { usePaletteVariant } from "./paletteVariant";

/**
 * App-wide MUI theme provider. The palette variant (shipped "brand2026" vs
 * staff-optional legacy "classic") comes from `usePaletteVariant()`; the mode
 * (light/dark) is managed by MUI's color-scheme mechanism — read/changed via
 * `useThemeMode()`. `noSsr` because Oak is a client-only SPA. Defaults to light.
 */
export function EncampThemeProvider({ children }: PropsWithChildren) {
  const { variant } = usePaletteVariant();
  const theme = useMemo(() => createEncampTheme(variant), [variant]);

  return (
    <ThemeProvider theme={theme} defaultMode="light" noSsr>
      {children}
    </ThemeProvider>
  );
}
